import {
  EnvelopeIcon,
  GlobeAltIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';

import { HANDLE_TYPES } from './types';

interface ChannelTypeBadgeProps {
  type: string;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'WEBSITE':
      return GlobeAltIcon;
    case 'MAILING_ADDRESS':
    case 'EMAIL':
      return EnvelopeIcon;
    case 'PHONE':
    case 'FAX':
      return PhoneIcon;
    default:
      return GlobeAltIcon;
  }
};

export const ChannelTypeBadge = ({ type }: ChannelTypeBadgeProps) => {
  const handleType = HANDLE_TYPES.find((ht) => ht.value === type);
  const Icon = getIcon(type);

  if (!handleType) return null;

  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-sm">
      <Icon className="h-4 w-4 text-gray-600" />
      <span className="font-medium text-gray-700">{handleType.shortLabel}</span>
    </div>
  );
};
